export default function ProfileSection() {
  const stats = [
    { value: '10+', label: '年演藝生涯' },
    { value: '200+', label: '作品累計' },
    { value: '15+', label: '寫真集出版' },
    { value: '300萬+', label: '社群粉絲' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="w-full lg:w-2/5">
            <div className="aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20portrait%20photography%20with%20warm%20soft%20natural%20lighting%2C%20cream%20backdrop%2C%20sophisticated%20editorial%20style%2C%20refined%20Japanese%20aesthetic%2C%20gentle%20expression%2C%20soft%20rose%20and%20beige%20tones%2C%20professional%20fashion%20portrait%20composition&width=600&height=800&seq=profile-yua&orientation=portrait"
                alt="三上悠亞個人資料"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-4">
              個人簡介
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-4">
              關於 三上悠亞
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              三上悠亞（日語：三上悠亜），1993年8月16日出生於日本愛知縣名古屋市。從偶像團體SKE48出發，歷經轉型與磨練，如今已成為日本最具代表性的寫真偶像與女演員之一。憑藉甜美外型、敬業態度與不斷突破自我的精神，三上悠亞在演藝圈贏得了廣大粉絲的支持與喜愛。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              出道超過十年，三上悠亞持續在各領域發光發熱。無論是寫真作品、戲劇演出，還是與粉絲的近距離互動，她始終以真誠與熱情面對每一個挑戰，也因此在亞洲各國累積了龐大的粉絲基礎。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-3 rounded-lg bg-background-100">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}